export default (spec) => {
  let { uid, workflow, form, siteid } = spec
  return {
    uid: uid,
    // tip: form.fields[0].tip,
    // class: form.fields[0].class,
    // title: form.fields[0].title,
    data: {},
    fingerprint: form.meta.fingerprint,
    targets: form.targets,
    fid: form.meta.fid,
    refresh: false,
    workflow: workflow,
    siteid: siteid,
    fields: form.fields[0].content
  }
}



// WEBPACK FOOTER //
// ./src/schema/form.js